import { Component } from "react";

import { MdSavedSearch } from "react-icons/md";

import { Wrapper, Input, Button } from "./Search.styled.js";

class GifSearch extends Component {
  state = {
    inputValue: "",
  };

  handleChange = (event) => {
    this.setState({ inputValue: event.target.value });
  };

  handleSubmit = () => {
    this.props.onSearch(this.state.inputValue);
    this.setState({ inputValue: "" });
  };

  render() {
    return (
      <Wrapper>
        <Input
          placeholder="Search..."
          type="text"
          value={this.state.inputValue}
          onChange={this.handleChange}
        />
        <Button onClick={this.handleSubmit}>
          Search <MdSavedSearch />
        </Button>
      </Wrapper>
    );
  }
}

export default GifSearch;
